import { render, staticRenderFns } from "./yh.vue?vue&type=template&id=f08e5226&scoped=true&"
import script from "./yh.vue?vue&type=script&lang=js&"
export * from "./yh.vue?vue&type=script&lang=js&"
import style0 from "./yh.vue?vue&type=style&index=0&id=f08e5226&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f08e5226",
  null
  
)

export default component.exports